export const FINANCIAL_STATEMENTS_LOAD = 'financialStatements.LOAD';
export const FINANCIAL_STATEMENTS_NEXT_TURN_LOAD = 'financialStatements.NEXT_TURN_LOAD'
export const FINANCIAL_STATEMENTS_LOST_INVENTORY_UPDATED =
	'financialStatements.LOST_INVENTORY_UPDATED';

export const FINANCIAL_STATEMENTS_SAVE_OPENING_INVENTORY_FOR_QUARTER =
	'financialStatements.SAVE_OPENING_INVENTORY_FOR_QUARTER';
export const FINANCIAL_STATEMENTS_SAVE_CONTRIBUTED_CAPITAL =
	'financialStatements.FINANCIAL_STATEMENTS_SAVE_CONTRIBUTED_CAPITAL';
export const FINANCIAL_STATEMENTS_UPDATE_SUBMISSION_STATUS_FOR_QUARTER =
	'financialStatements.UPDATE_SUBMISSION_STATUS_FOR_QUARTER';
export const FINANCIAL_STATEMENTS_UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER =
	'financialStatements.UPDATE_RATIOS_SUBMISSION_STATUS_FOR_QUARTER';
export const FINANCIAL_STATEMENTS_UPDATE_CAN_SUBMIT_FINANCIAL_STATEMENTS =
	'financialStatements.UPDATE_CAN_SUBMIT_FINANCIAL_STATEMENTS';

export const FINANCIAL_STATEMENTS_UPDATE_INCOME_STATEMENT_FOR_QUARTER =
	'financialStatements.UPDATE_INCOME_STATEMENT_FOR_QUARTER';
export const FINANCIAL_STATEMENTS_UPDATE_BALANCE_SHEET_FOR_QUARTER =
	'financialStatements.UPDATE_BALANCE_SHEET_FOR_QUARTER';
export const FINANCIAL_STATEMENTS_UPDATE_FINANCIAL_RATIOS_FOR_QUARTER =
	'financialStatements.UPDATE_FINANCIAL_RATIOS_FOR_QUARTER';

export const FINANCIAL_STATEMENTS_SYSTEM_UPDATE_ALL_FOR_QUARTER =
	'financialStatements.SYSTEM_UPDATE_ALL_FOR_QUARTER';
export const FINANCIAL_STATEMENTS_SYSTEM_UPDATE_BALANCE_SHEET_FOR_QUARTER =
	'financialStatements.SYSTEM_UPDATE_BALANCE_SHEET_FOR_QUARTER';

export const FINANCIAL_STATEMENTS_DISTRIBUTE_PROFIT = 
	'financialStatements.DISTRIBUTE_PROFIT';
export const FINANCIAL_STATEMENTS_SET_OPENING_RETAINED_EARNINGS_FOR_MONTH =
	'SET_OPENING_RETAINED_EARNINGS_FOR_MONTH';
export const FINANCIAL_STATEMENTS_UPDATE_CURRENT_RETAINED_EARNINGS =
	'UPDATE_CURRENT_RETAINED_EARNINGS';

export const FINANCIAL_STATEMENTS_UPDATE_ACCOUNT_RECEIVABLES =
	'financialStatements.UPDATE_ACCOUNT_RECEIVABLES';

export const FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_STATEMENTS = 
	'financialStatements.SET_HAS_ATTEMPTED_TO_SUBMIT_STATEMENTS';
export const FINANCIAL_STATEMENTS_SET_HAS_ATTEMPTED_TO_SUBMIT_RATIOS = 
	'financialStatements.SET_HAS_ATTEMPTED_TO_SUBMIT_RATIOS';

export const FINANCIAL_STATEMENTS_SET_SUBMISSION_ERRORS_CONFIGURATION =
	'financialStatements.SET_SUBMISSION_ERRORS_CONFIGURATION';
export const FINANCIAL_STATEMENTS_SET_ERROR_MESSAGES =
	'financialStatements.SET_ERROR_MESSAGES';
export const FINANCIAL_STATEMENTS_RESET_ERROR_HANDLING =
	'financialStatements.RESET_ERROR_HANDLING';
export const FINANCIAL_STATEMENTS_UPDATE_RATIOS_ERROR_FIELD =
	'UPDATE_RATIOS_ERROR_FIELD';

export const FINANCIAL_STATEMENTS_SET_DISPLAYED_STATEMENT =
	'financialStatements.SET_DISPLAYED_STATEMENT';

export const FINANCIAL_STATEMENTS_SET_FINANCIAL_RATIOS_CARD_OPEN =
	'financialStatements.SET_FINANCIAL_RATIOS_CARD_OPEN';
